var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwooshHeart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "90px",
    height: "90px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 90 90",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\n    .fil0 {fill:black}\n\n  "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_507410992"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M50 38c8,-2 12,2 12,7 0,4 -6,10 -7,11 -1,1 12,-7 10,-15 -1,-7 -8,-7 -15,-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M43 75c0,0 7,6 8,8 1,3 -2,0 4,-9 7,-12 32,-28 25,-43 -5,-12 -24,-16 -34,-4 0,0 -6,-22 -23,-21 -16,0 -19,24 -8,40 11,16 26,27 26,27 -3,-2 -31,-33 -24,-50 6,-15 22,-5 26,6 0,0 -5,7 -4,12 1,4 5,4 7,1 1,-3 2,-9 1,-12 -1,-1 12,-5 19,-1 8,4 11,15 4,23 -7,9 -5,7 -27,23zm1 -42c0,0 0,9 -1,9 -2,-1 -1,-4 1,-9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwooshHeart1);
export default __webpack_public_path__ + "static/media/swoosh-heart-1.1efc4741aead2fbef899106af480e6f9.svg";
export { ForwardRef as ReactComponent };